import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';

import {
  RemoteConfigStore,
  BOOKING_PARAMS,
  AuthStore,
  BookingSubscriptionPackageOptions,
  BookingStore,
} from '@store';

@Component({
  selector: 'app-booking-wrapper',
  templateUrl: './booking-wrapper.component.html',
  styleUrls: ['./booking-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingWrapperComponent implements OnInit, OnDestroy {
  invoiceNumber: string;
  isHardwareBundlingAvailable: boolean;
  BookingSubscriptionPackageOptions = BookingSubscriptionPackageOptions;

  constructor(
    public remoteConfigStore: RemoteConfigStore,
    public authStore: AuthStore,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private bookingStore: BookingStore
  ) {}

  ngOnInit(): void {
    this.invoiceNumber = this.activatedRoute.snapshot.queryParams[BOOKING_PARAMS.INVOICE_NUMBER];

    this.remoteConfigStore.isHardwareBundlingAvailable$
      .pipe(first())
      .subscribe((isHardwareBundlingAvailable) => {
        this.isHardwareBundlingAvailable = isHardwareBundlingAvailable;

        if (!isHardwareBundlingAvailable) {
          const params = { ...this.activatedRoute.snapshot.queryParams };
          delete params[BOOKING_PARAMS.INVOICE_NUMBER];
          this.router.navigate([], { queryParams: params });
        }
      });
  }

  ngOnDestroy(): void {
    this.bookingStore.clearBookingState();
  }
}
